<!--仓库管理 入库 页面ID 10500-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="订单ID：">
            <el-input size="medium" v-model="searchForm.ORDER_ID" />
          </el-form-item>
          <el-form-item label="供应商：">
            <el-select size="medium" filterable v-model="searchForm.SUPPLIER_ID" placeholder="请选择供应商" :clearable="true">
              <el-option v-for="item in supplierList" :key="item.SUPPLIER_ID" :label="item.NAME"
                :value="item.SUPPLIER_ID" />
            </el-select>
          </el-form-item>
          <el-form-item label="送货日期：">
            <el-date-picker size="medium" v-model="searchForm.SEND_DAY" type="date" placeholder="选择日期"
              style="width: 200px" :clearable="true" />
          </el-form-item>
          <el-button size="medium" type="primary" :loading="loading" @click="doQueryTable()">筛选</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="manualInsotck()" v-if="WAREHOUSE_MODE == 2">手动录入</el-button>
        <el-button size="medium" :loading="loading" @click="shortcutStorage()">一键入库</el-button>
        <el-button size="medium" @click="giftsInstock()" v-if="fun_dic[1050001]">赠品入库</el-button>
        <el-button size="medium" type="primary" plain :loading="loading" @click="exportCurrentOrder()">
          导出当天入库单和供应商
        </el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table @selection-change="handleSelectionChange" border stripe :data="tableData" style="margin-top: 20px">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="ORDER_ID" label="订单ID" width="80"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
          <el-table-column prop="REAL_TOTAL_GYS_FEE" label="总金额"></el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="outWarehouse(scope.row)">入库</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 打印 -->
    <el-dialog title="是否打印订单" center :visible.sync="printVisible" width="500px">
      <div slot="footer" class="dialog-footer">
        <el-button @click="printVisible = false">取 消</el-button>
        <el-button @click="submitPrint">打印</el-button>
      </div>
    </el-dialog>
    <!-- 分页 -->
    <div class="pagination_box" v-show="total_count > 10">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="total_count">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  queryInStorageFun, exportCurrent, shortcutStorage, print,
} from 'api/warehouseManager';
import { haveGYSFun } from 'api/shopOrderManage';
import { getActionFun } from 'api/login';
import date from '@/assets/common/date';

export default {
  data () {
    return {
      PAGE_ID: '10500', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1050001: 0 },
      searchForm: {},
      tableData: [],
      total_count: 0,
      pageSize: 10,
      currentPage: 1,
      loading: false,
      supplierList: [],
      orderList: [],
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      printVisible: false,
      printList: [],
      companyName: sessionStorage.getItem('company'),
      preparer: sessionStorage.getItem('name'),
    };
  },
  created () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.STOCK_IN_CONDITION) {
      this.currentPage = this.STOCK_IN_CONDITION.CURRENT_PAGE;
      this.searchForm = this.STOCK_IN_CONDITION.CONDITION;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryAllSupplier();
    this.queryBeforeFun();
  },
  computed: {
    STOCK_IN_CONDITION () {
      return this.$store.state.STOCK_IN_CONDITION;
    },
  },
  methods: {
    // 控制功能按钮
    async queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      await getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 分页
    handleCurrentChange (e) {
      this.currentPage = e;
      this.queryData();
    },
    queryAllSupplier () {
      const params = {};
      haveGYSFun(params).then((result) => {
        if (result.length !== 0) {
          this.supplierList = this.$util.listRemoveDuplicates(result[0].list.map(({ SUPPLIER_ID, NAME }) => ({ SUPPLIER_ID, NAME })));
        } else {
          this.supplierList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    doQueryTable () {
      this.currentPage = 1;
      this.queryData();
    },
    queryData () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.SEND_DAY) {
        params.ORDER_DAY = date(this.searchForm.SEND_DAY, '%F');
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      this.loading = true;
      queryInStorageFun(params).then((result) => {
        if (result[0].list) {
          this.tableData = result[0].list;
          this.total_count = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_STOCK_IN_CONDITION', {
            CURRENT_PAGE: this.currentPage,
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.total_count,
          });
        } else {
          this.tableData = [];
          this.total_count = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    outWarehouse (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('ORDER_CODE', row.ORDER_CODE);
      sessionStorage.setItem('SUPPLIER_NAME', row.SUPPLIER_NAME);
      sessionStorage.setItem('SEND_DAY', row.SEND_DAY);
      this.$router.push({ path: '/stockEnterDetail/detail' });
    },
    // 导出当天供应商和订单
    async exportCurrentOrder () {
      const filePath = await exportCurrent();
      window.location.href = filePath[0].FILE_PATH;
    },
    manualInsotck () {
      this.$router.push({ name: 'manualInstock' });
    },
    // 赠品入库
    giftsInstock () {
      this.$router.push({ name: 'giftsInstock' });
    },
    // 多选
    handleSelectionChange (val) {
      const orderList = [];
      val.forEach((item) => { orderList.push(item.ORDER_ID); });
      this.orderList = orderList;
    },
    // 一键入库
    shortcutStorage () {
      if (this.orderList.length <= 0) {
        this.$message.show({ text: '请勾选需要入库的订单', type: 'warning' });
        return;
      }
      const params = {
        ORDER_ID_LIST: this.orderList,
      };
      shortcutStorage(params).then((result) => {
        this.queryData();
        this.orderList = [];
        if (result[0].FILE_PATH == '') {
          this.$message.show({ text: '入库成功', type: 'success' });
        } else {
          this.$message.show({ text: '部分订单入库失败，请查看失败原因', type: 'warning' });
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        }
        if (result[0].PRINT_DATA.length <= 0) {

        } else {
          this.printVisible = true;
          this.printList = result[0].PRINT_DATA;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 打印
    submitPrint () {
      let html = '<div>';
      html += '<div class="main" >';
      this.printList.forEach((item, index) => {
        html += `<div class="title">${this.companyName}入库单</div>`;
        html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">供应商：${item[0].ORDER_TITLE[0].SUPPLIER_NAME}</div><div>送货日期：${item[0].ORDER_TITLE[0].SEND_DAY}</div></div>`;
        html += `<div class="head" style="font-size: 20px;"><div class="code" style="font-size: 20px;">订单编号：${item[0].ORDER_TITLE[0].ORDER_CODE}</div><div>制单人：${this.preparer}</div></div>`;
        html += '<table border="1" cellspacing="0" style="position:relative; width:98%;"><div class="el-table__body el-table__header">';
        html += '<tr style="text-align: center"><td style="width: 40px">序号</td><td>名称</td> <td>单位</td> <td>产品编码</td> <td  style="width: 40px">单价</td> <td style="width: 70px">入库数量</td> <td  style="width: 70px">入库金额</td></tr>';
        html += '</div><div class="el-table__body">';
        item[0].ORDER_DETAIL.forEach((orderItem, orderIndex) => {
          html += '<tr style="text-align: center;font-size: 14px">';
          html += `<td> ${orderIndex + 1} </td> <td>${orderItem.PRODUCT_NAME}</td> <td>${orderItem.TYPE_UNIT}</td><td>${orderItem.PRODUCT_CODE}</td><td>${orderItem.REAL_PRICE}</td>
                        <td>${orderItem.REAL_COUNT}</td> <td>${orderItem.REAL_FEE} </td>`;
          html += '</tr>';
        });
        html += '</div>';
        html += '</table>';
        html += `<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 16px;"><div style="flex: 1; font-size: 16px;">入库时间：</div><div  style="flex: 1; font-size: 16px;">入库总金额：${item[0].ORDER_TITLE[0].REAL_TOTAL_GYS_FEE}</div></div>`;
        if (sessionStorage.getItem('tcId') == 5903) {
          html += '<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 16px;"><div style="font-size: 16px; flex: 1;">收货人：</div></div>';
        } else {
          html += '<div style="margin-top: 20px; display: flex; flex-direction: row; font-size: 16px;"><div style="font-size: 16px; flex: 1;">主管：</div><div  style="flex: 1; font-size: 16px;">验收：</div><div style="flex: 1; font-size: 16px;">制单：</div></div>';
        }
        html += '<div style="page-break-after: always;"></div>';
      });
      html += '</div>';
      html += '</div>';

      const windows = print(html);
      windows.close();
    },
  },
};
</script>
<style scoped>
.pagination_box {
  float: right;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockEnter.vue